export default __webpack_public_path__ + "ab24b5ce2e1118a8f6679ad256fd89b2.svg";